import {
  ContentLibraryCategoryDto,
  ContentLibraryCategoryItemDto,
} from '@asset-metrix/portal-gateway-client-js';

export function visibleCategoryItems(
  items: readonly ContentLibraryCategoryItemDto[],
  categoryIndex: number,
  selectedTags: readonly string[],
  validPaths: readonly (readonly string[])[]
): ContentLibraryCategoryItemDto[] {
  return items.filter((item) =>
    validPaths.some(
      (path) =>
        path[categoryIndex] === item.tagName &&
        path
          .slice(0, categoryIndex)
          .every((tag, index) => tag === selectedTags[index])
    )
  );
}

/**
 * Earlier selections constrain later categories. A stored selection is kept
 * when it is still visible; otherwise the first remaining visible item is used.
 */
export function resolveCategorySelections(
  categories: readonly ContentLibraryCategoryDto[],
  validPaths: readonly (readonly string[])[],
  overrides: Readonly<Record<string, string>>
): Record<string, string> {
  const selections: Record<string, string> = {};
  const selectedTags: string[] = [];

  for (const [index, category] of categories.entries()) {
    const visible = visibleCategoryItems(
      category.items,
      index,
      selectedTags,
      validPaths
    );
    const override = overrides[category.id];
    const tagName =
      override != null && visible.some((item) => item.tagName === override)
        ? override
        : visible[0]?.tagName;
    if (tagName == null) {
      continue;
    }
    selections[category.id] = tagName;
    selectedTags.push(tagName);
  }

  return selections;
}

export function categoriesWithVisibleItems(
  categories: readonly ContentLibraryCategoryDto[],
  validPaths: readonly (readonly string[])[],
  selections: Readonly<Record<string, string>>
): ContentLibraryCategoryDto[] {
  const selectedTags = categories.map(
    (category) => selections[category.id] ?? ''
  );

  return categories.map((category, index) => ({
    ...category,
    items: visibleCategoryItems(
      category.items,
      index,
      selectedTags,
      validPaths
    ),
  }));
}
